import { TemplateAlarmToolbarProps } from '@/template/interface'
import { getFormatMessage } from '@/utils/utils'
import { SearchOutlined } from '@ant-design/icons'
import { Button, Form, Input, Space } from 'antd'
import React from 'react'

export const TemplateAlarmToolbar: React.FC<TemplateAlarmToolbarProps> = (
  props: TemplateAlarmToolbarProps
) => {
  const formatMessage = getFormatMessage()
  const [form] = Form.useForm()

  const handleReset = () => {
    form.resetFields()
    if (props.onSearch) {
      props.onSearch(form.getFieldsValue())
    }
  }

  const handleSubmit = () => {
    if (props.onSearch) {
      props.onSearch(form.getFieldsValue())
    }
  }

  return (
    <Form form={form} layout='inline' style={{ marginBottom: 16 }}>
      <Form.Item name='name'>
        <Input
          allowClear={true}
          placeholder={formatMessage({
            id: 'app.template.alarm.toolbar.name'
          })}
        />
      </Form.Item>
      <Form.Item>
        <Button type='link' onClick={handleReset}>
          {formatMessage({
            id: 'app.template.alarm.toolbar.clear'
          })}
        </Button>
        <Button type='primary' onClick={handleSubmit} icon={<SearchOutlined />}>
          {formatMessage({
            id: 'app.template.alarm.toolbar.search'
          })}
        </Button>
      </Form.Item>
      <Form.Item style={{ marginLeft: 'auto' }}>
        <Space>
          <Button type='primary' onClick={() => props.onCreate?.()}>
            {formatMessage({ id: 'app.template.alarm.toolbar.create' })}
          </Button>

          <Button
            type='primary'
            disabled={!props.selectable}
            onClick={() => props.onBatchDelete?.()}
          >
            {formatMessage({ id: 'app.template.alarm.toolbar.batchDelete' })}
          </Button>
        </Space>
      </Form.Item>
    </Form>
  )
}
